import React, { useEffect, useState } from 'react';
import AgyleDictionaryField from '../../../../../../components/ui/selector/agyleDictionaryField';
import { isEmpty } from 'lodash';
import { prescriptionTerminologyApi } from '../../../../../../app/apiPrescription';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import MedicationIcon from '@mui/icons-material/Medication';
import InformationBox from '../../../../../../components/other/informationBox';
import AgyleButton from '../../../../../../components/ui/buttons/agyleButton';
import { Typography } from '@mui/material';
import AgyleLoadingSpinner from '../../../../../../components/other/agyleLoadingSpinner';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';

const MedicineDetailsAutocomplete = ({
    value,
    handleChangeValue,
    handleChangeRoute,
    mainCode,
    placeholder = null,
    disabled = false,
    onClose,
}) => {
    const { t } = useTranslation();
    const controller = new AbortController();

    // Input states
    const [inputOpen, setInputOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [showSelector, setShowSelector] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    // Value
    const [inputValue, setInputValue] = useState(null);

    // Search
    useEffect(() => {
        console.log('mainCode', mainCode);

        if (!isEmpty(mainCode)) {
            setIsLoading(true);
            setInputOpen(true);

            prescriptionTerminologyApi
                .getDetails({ snomedCode: mainCode, signal: controller.signal })
                .then((result) => {
                    if (controller.signal.aborted) return;

                    if (result?.children) {
                        setOptions(result.children);
                    } else {
                        setOptions([]);
                    }

                    if (handleChangeRoute && result) {
                        handleChangeRoute(result?.route, result?.form, result?.unit_dose_unit);
                    }

                    setIsLoading(false);
                })
                .catch(function (error) {
                    console.error('Autocomplete dictionaries error', error);
                    if (!controller.signal.aborted) {
                        setOptions([]);
                        setIsLoading(false);
                    }
                })
                .finally(() => {
                    setDataLoaded(true);
                });
        } else {
            // Resetuj opcje gdy input jest za krótki
            setOptions([]);
            setIsLoading(false);

            setDataLoaded(true);
            setShowSelector(false);
        }

        return () => {
            controller.abort();
        };
    }, [mainCode]);

    useEffect(() => {
        return () => {
            controller.abort();
        };
    });

    // Prepopulate value
    useEffect(() => {
        setInputValue(value ?? null);
        if (!value) {
            setShowSelector(false);
        }
    }, [value]);

    const handleAutocompleteState = (val) => {
        setInputOpen(val);
    };

    const handleChange = (_, newValues) => {
        // TODO
        handleChangeValue(newValues);
        setInputOpen(false);
    };

    if (isLoading && !dataLoaded) {
        return <AgyleLoadingSpinner />;
    }

    if (dataLoaded && !isEmpty(options) && !showSelector) {
        return (
            <InformationBox type="info" style={{ marginTop: 0 }}>
                <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>
                        {t('More specific options (e.g., brand, manufacturer or packaging type) are available for this product.')}
                    </Typography>
                    <div>
                        <AgyleButton onClick={() => setShowSelector(true)} disabled={disabled}>
                            {t('Show')}
                        </AgyleButton>
                    </div>
                </Box>
            </InformationBox>
        );
    }

    // Don't render input if there are no child options
    if (dataLoaded && isEmpty(options)) return null;
    if (value) return null;

    const renderEndAdornment = () => {
        // if (onClose) {
        return (
            <Box
                sx={{
                    pr: 3,
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.secondary',
                }}
            >
                <IconButton
                    size="small"
                    fontSize="small"
                    onClick={() => {
                        if (onClose) {
                            onClose();
                        } else {
                            setShowSelector(false);
                        }
                    }}
                >
                    <CancelIcon fontSize="small" />
                </IconButton>
            </Box>
        );
        // }
        //
        // return null;
    };

    return (
        <div style={{ width: '100%' }}>
            <AgyleDictionaryField
                size="small"
                noBorder={false}
                withNewBackground
                open={inputOpen}
                onOpen={handleAutocompleteState.bind(this, true)}
                onClose={handleAutocompleteState.bind(this, false)}
                disabled={disabled || !isEmpty(value)}
                isOptionEqualToValue={(option, value) => option?.code === value?.code}
                getOptionLabel={(option) => option.display}
                options={options}
                loading={isLoading}
                // filterOptions={(x) => x}
                loadingText={t('Loading data ...')}
                value={value}
                onChange={handleChange}
                disableClearable
                placeholder={placeholder}
                startIcon={
                    <Box
                        sx={{
                            pl: 1,
                            display: 'flex',
                            alignItems: 'center',
                            color: 'text.secondary',
                        }}
                    >
                        <SearchIcon />
                    </Box>
                }
                endAdornmentAddons={renderEndAdornment}
                renderOption={(props, option) => (
                    <Box
                        component="li"
                        {...props}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                        }}
                    >
                        <Box
                            sx={{
                                color: 'text.secondary',
                                display: 'flex',
                            }}
                        >
                            <MedicationIcon />
                        </Box>
                        {option.display}
                    </Box>
                )}
            />
        </div>
    );
};

export default MedicineDetailsAutocomplete;
